import { UnicornIcon } from '@compass/Icon'
import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

// The product id is `device_rarity`, but the event field Warden emits is `rare_device`.
export const deviceRarityDefinition: SmartSignalDefinition<{ rare_device?: boolean }> = {
  key: 'device-rarity',
  label: 'Rare device',
  extract: (e) => ({ rare_device: e.rare_device }),
  icon(e) {
    const p = this.extract(e)?.rare_device
    return (
      <UnicornIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.rare_device
    return p === true
  },
  isWeb: () => true,
  isMobile: () => false,
  searchFor: '"rare_device":',
  documentationHash: '#device-rarity-detection',
  urlParamKey: IdentificationUrlKeys.DeviceRarity,
}
